import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import type { DocumentTypeDatabase } from '../../../../types';
import useDocumentTypeMenuAction from './useDocumentTypeMenuAction';

type Props = {
  type: DocumentTypeDatabase;
  onEdit: (type: DocumentTypeDatabase) => void;
  onDelete: (type: DocumentTypeDatabase) => void;
};

export default function DocumentTypeMenuAction(props: Props) {
  const hook = useDocumentTypeMenuAction(props);

  return (
    <ResourceMenuActions
      size="small"
      tooltip={`Options de ${props.type.name}`}
      actions={[
        {
          id: 'rename',
          label: 'Renommer',
          icon: <EditIcon fontSize="small" />,
          onClick: hook.handleEdit,
        },
        // Default types cannot be deleted (the database refuses it).
        props.type.is_system ? null : {
          id: 'delete',
          label: 'Supprimer',
          icon: <DeleteIcon fontSize="small" />,
          onClick: hook.handleDelete,
        },
      ]}
    />
  );
}
